import { mapState } from 'vuex';
export default {
  name: 'SelectAsyncField',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    selectOptions: {
      type: Array,
      default: () => []
    },
    isLoadingOptions: {
      type: Boolean,
      default: false
    },
    searchTerm: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    canLoadMore: {
      type: Boolean,
      default: false
    },
    isLoadingMore: {
      type: Boolean,
      default: false
    },
    canAddRule: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    searchInputSync: {
      get() {
        return this.searchTerm;
      },
      set(value) {
        this.$emit('search-input', value);
      }
    }
  },
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.$emit('intersect', entries);
      }
    }
  }
};